// extracted by mini-css-extract-plugin
module.exports =  {"story":"story--xKQtA","story-content":"story-content--WN_Gb","storyContent":"story-content--WN_Gb","bg":"bg--qjbjl"};